import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Dashboard from "../pages/dashboard/page";
import OrdersPage from "../pages/orders/page";
import ProductionPage from "../pages/production/page";
import CargoPage from "../pages/cargo/page";
import MessagesPage from "../pages/messages/page";
import FinancePage from "../pages/finance/page";
import ProductsPage from "../pages/products/page";
import ReportsPage from "../pages/reports/page";
import SettingsPage from "../pages/settings/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "orders",
        element: <OrdersPage />,
      },
      {
        path: "production",
        element: <ProductionPage />,
      },
      {
        path: "cargo",
        element: <CargoPage />,
      },
      {
        path: "messages",
        element: <MessagesPage />,
      },
      {
        path: "finance",
        element: <FinancePage />,
      },
      {
        path: "products",
        element: <ProductsPage />,
      },
      {
        path: "reports",
        element: <ReportsPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;